// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__Q6tKo","title":"style_title__U_UxA","link":"style_link__7_Q9Z","text":"style_text__KuWom","indent":"style_indent__ubiTL"};